/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integration_WorkingInputs */

const en_integration_working = /** @type {(inputs: Integration_WorkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connecting or importing files…`)
};

const es_integration_working = /** @type {(inputs: Integration_WorkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectando o importando archivos…`)
};

/**
* | output |
* | --- |
* | "Connecting or importing files…" |
*
* @param {Integration_WorkingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const integration_working = /** @type {((inputs?: Integration_WorkingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integration_WorkingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_integration_working(inputs)
	return en_integration_working(inputs)
});